import "./fcopel/style.css";
import { Sectionpd} from "../componentes/padroes";
import { Sectioninterna, Btnnav, Desctablet, Paragrafoint, Navcommand, Tags, Flexmidbanner, InternoBanner } from "./padroespages";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function Shark() {
  return (
    <main>
        <Helmet>
            <title>Shark Narguile - Gabriel Barbosa</title>
            <meta name="description" content="E-commerce desenvolvido para a venda de narguiles e variedade de produtos destinados ao consumo adulto. Feito utilizando a plataforma da Tray E-commerce" />
        </Helmet>
        <InternoBanner style={{ backgroundImage: 'url(/img/clientes/banner_shark.jpg'}}>
            <div className="container z-2">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <div className="descbannerint">
                            <h1>SHARK NARGUILE</h1>
                            <Flexmidbanner>
                                <a href="https://www.sharknarguile.com.br" target="_blank" rel="noreferrer">sharknarguile.com.br</a>
                                <span>VIA CRT COMUNICAÇÃO</span>
                            </Flexmidbanner>
                            <Tags>//E-COMMERCE + BANCO DE DADOS + INTEGRAÇÃO</Tags>
                            <Paragrafoint>E-commerce desenvolvido para a venda de narguiles e variedade de produtos destinados ao consumo adulto. Feito utilizando a plataforma da Tray E-commerce</Paragrafoint>  
                        </div>
                    </div>
                </div>
            </div>
        </InternoBanner>
        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/shark_home.png" alt="Home do Shark Narguiles    " />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                        <Desctablet>Por ser um site direcionado à vendas, foi construido pela plataforma de e-commerce Tray, focado em funcionalidades específicas utilizando do Twig para atender às solicitações especiais pelo cliente. Entre as funcionalidades implementadas temos como características principais a criação do carrinho de compras, integração de cupons de desconto, exibição de produtos em destaque.</Desctablet>
                    </div>
                </div>
            </div>
        </Sectioninterna>

        <Sectioninterna>
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12">
                        <div className="destaque-image">
                            <div className="mockup-container">
                                <img src="/img/clientes/tablet.png" className="tablet-mockup" alt="Tablet" />

                                <div className="site-preview">
                                    <img src="/img/clientes/shark_interna.png" alt="Shark Narguile Interna" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8">
                    </div>
                </div>
            </div>
        </Sectioninterna>
        <Sectionpd>
            <div className="container">
                <div className="row">
                    <div className="col-6 order-1 order-lg-0 col-lg-5 align-content-lg-center col-5 justify-content-lg-end text-lg-end">
                        <Link to="/fundaffemg" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//ANTERIOR</span>
                                <h3>Fundaffemg</h3>
                                <span>//FRONT-END + INTEGRAÇÃO + WORDPRESS + HOSPEDAGEM</span>
                            </Btnnav>
                        </Link>
                    </div>
                    <div className="col-12 order-0 col-lg-2 order-lg-1">
                        <Navcommand>
                            <Link to="/fundaffemg" style={{ textDecoration: 'none' }}></Link>
                            <span></span>
                            <Link to="/fcopel" style={{ textDecoration: 'none' }}></Link>
                        </Navcommand>
                    </div>
                    <div className="col-6 order-2 col-lg-5 order-lg-2 align-content-lg-center col-5 justify-content-lg-end">
                        <Link to="/fcopel" style={{ textDecoration: 'none' }}>
                            <Btnnav>
                                <span>//PRÓXIMO</span>
                                <h3>FUNDAÇÃO COPEL</h3>
                                <span>//FRONT-END + BANCO DE DADOS + WORDPRESS</span>
                            </Btnnav>
                        </Link> 
                    </div>
                </div>
            </div>
        </Sectionpd>
    </main>
  );
}

export default Shark;